import React, { useMemo, useState } from 'react';
import {
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Pagination,
  Row,
  Table
} from 'react-bootstrap';

const ApiPartnerCommissionReport = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
  const [searchQuery, setSearchQuery] = useState('');

  const commissionData = [
    {
      id: 'APC001',
      date: '2025-11-07',
      mobile: '9876543210',
      orderId: 'ORD-AP-5501',
      txnType: 'Credit',
      amount: 128500.0,
      serviceCharge: 2250.0,
      commission: 4850.0,
      tds: 485.0,
      status: 'Settled'
    },
    {
      id: 'APC002',
      date: '2025-11-07',
      mobile: '9123456789',
      orderId: 'ORD-AP-5496',
      txnType: 'Debit',
      amount: 6120.0,
      serviceCharge: 180.0,
      commission: 0,
      tds: 0,
      status: 'Settled'
    },
    {
      id: 'APC003',
      date: '2025-11-06',
      mobile: '8765432109',
      orderId: 'ORD-AP-5488',
      txnType: 'Credit',
      amount: 48500.0,
      serviceCharge: 950.0,
      commission: 1750.0,
      tds: 87.5,
      status: 'Settled'
    },
    {
      id: 'APC004',
      date: '2025-11-05',
      mobile: '9988776655',
      orderId: 'ORD-AP-5471',
      txnType: 'Debit',
      amount: 15200.0,
      serviceCharge: 0,
      commission: 0,
      tds: 0,
      status: 'Pending'
    },
    {
      id: 'APC005',
      date: '2025-11-04',
      mobile: '7654321098',
      orderId: 'ORD-AP-5460',
      txnType: 'Credit',
      amount: 22100.0,
      serviceCharge: 440.0,
      commission: 780.0,
      tds: 39.0,
      status: 'Settled'
    },
    {
      id: 'APC006',
      date: '2025-11-03',
      mobile: '9876543211',
      orderId: 'ORD-AP-5446',
      txnType: 'Debit',
      amount: 32500.0,
      serviceCharge: 650.0,
      commission: 0,
      tds: 0,
      status: 'Settled'
    },
    {
      id: 'APC007',
      date: '2025-11-03',
      mobile: '8899776655',
      orderId: 'ORD-AP-5441',
      txnType: 'Credit',
      amount: 7850.0,
      serviceCharge: 0,
      commission: 140.0,
      tds: 7.0,
      status: 'Settled'
    },
    {
      id: 'APC008',
      date: '2025-11-02',
      mobile: '7788996655',
      orderId: 'ORD-AP-5433',
      txnType: 'Debit',
      amount: 18400.0,
      serviceCharge: 0,
      commission: 0,
      tds: 0,
      status: 'On Hold'
    },
    {
      id: 'APC009',
      date: '2025-11-01',
      mobile: '9966554433',
      orderId: 'ORD-AP-5422',
      txnType: 'Credit',
      amount: 9650.0,
      serviceCharge: 140.0,
      commission: 450.0,
      tds: 22.5,
      status: 'Settled'
    },
    {
      id: 'APC010',
      date: '2025-11-01',
      mobile: '8877665544',
      orderId: 'ORD-AP-5418',
      txnType: 'Debit',
      amount: 5210.0,
      serviceCharge: 99.0,
      commission: 0,
      tds: 0,
      status: 'Settled'
    },
    {
      id: 'APC011',
      date: '2025-10-31',
      mobile: '9876543212',
      orderId: 'ORD-AP-5403',
      txnType: 'Credit',
      amount: 18900.0,
      serviceCharge: 360.0,
      commission: 630.0,
      tds: 31.5,
      status: 'Settled'
    },
    {
      id: 'APC012',
      date: '2025-10-31',
      mobile: '9123456788',
      orderId: 'ORD-AP-5399',
      txnType: 'Debit',
      amount: 31200.0,
      serviceCharge: 0,
      commission: 0,
      tds: 0,
      status: 'Pending'
    },
    {
      id: 'APC013',
      date: '2025-10-30',
      mobile: '8765432108',
      orderId: 'ORD-AP-5385',
      txnType: 'Credit',
      amount: 14200.0,
      serviceCharge: 210.0,
      commission: 420.0,
      tds: 21.0,
      status: 'Settled'
    },
    {
      id: 'APC014',
      date: '2025-10-29',
      mobile: '9988776656',
      orderId: 'ORD-AP-5377',
      txnType: 'Credit',
      amount: 10400.0,
      serviceCharge: 156.0,
      commission: 360.0,
      tds: 18.0,
      status: 'Settled'
    },
    {
      id: 'APC015',
      date: '2025-10-28',
      mobile: '7654321099',
      orderId: 'ORD-AP-5366',
      txnType: 'Debit',
      amount: 11800.0,
      serviceCharge: 0,
      commission: 0,
      tds: 0,
      status: 'Settled'
    }
  ];

  const filteredData = useMemo(() => {
    if (!searchQuery) {
      return commissionData;
    }

    return commissionData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [commissionData, searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatCurrency = (value) => `₹${Number(value).toFixed(2)}`;

  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <Container fluid className="commission-reports-page p-4">
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    Commission Reports
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {[
                        'Date',
                        'Mobile No.',
                        'Order ID',
                        'Txn Type',
                        'amount',
                        'Service Charge',
                        'Commission',
                        'TDS',
                        'status'
                      ].map((column) => (
                        <th
                          key={column}
                          style={{
                            padding: '12px 16px',
                            fontWeight: 600,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '13px'
                          }}
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((row) => (
                        <tr key={row.id} style={{ transition: 'background-color 0.2s' }}>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{row.date}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 500 }}>{row.mobile}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{row.orderId}</td>
                          <td style={{ padding: '12px 16px' }}>
                            <span
                              className={`badge rounded-pill ${
                                row.txnType === 'Credit' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                              }`}
                              style={{ fontSize: '11px' }}
                            >
                              {row.txnType}
                            </span>
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                            {formatCurrency(row.amount)}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{formatCurrency(row.serviceCharge)}</td>
                          <td style={{ padding: '12px 16px', color: '#198754', fontSize: '13px', fontWeight: 600 }}>{row.commission ? formatCurrency(row.commission) : '-'}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{row.tds ? formatCurrency(row.tds) : '-'}</td>
                          <td style={{ padding: '12px 16px', color: row.status === 'Settled' ? '#198754' : row.status === 'Pending' ? '#fd7e14' : '#0d6efd', fontSize: '13px' }}>
                            {row.status}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center py-4" style={{ color: '#999' }}>
                          No commission records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {filteredData.length === 0 ? 0 : indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredData.length)} of {filteredData.length}
                  </div>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Pagination className="mb-0">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                    {getPaginationItems()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .commission-reports-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default ApiPartnerCommissionReport;


